exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-dialog__body {\n  padding: 0;\n}\n\n.el-dialog__header {\n  padding: 0;\n}\n\n.el-dialog, .el-pager li {\n  background: 0;\n  -webkit-box-sizing: border-box;\n}\n\n.flag-list-box {\n  background-color: #fff;\n}\n", "", {"version":3,"sources":["D:/company/demry_pc/src/assets/D:/company/demry_pc/src/assets/common.css"],"names":[],"mappings":"AAAA;EACE,WAAW;CACZ;;AAED;EACE,WAAW;CACZ;;AAED;EACE,cAAc;EACd,+BAA+B;CAChC;;AAED;EACE,uBAAuB;CACxB","file":"common.css","sourcesContent":[".el-dialog__body {\n  padding: 0;\n}\n\n.el-dialog__header {\n  padding: 0;\n}\n\n.el-dialog, .el-pager li {\n  background: 0;\n  -webkit-box-sizing: border-box;\n}\n\n.flag-list-box {\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/common.css
// module id = Buyk
// module chunks = 9